import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AppConstants } from 'src/app/app.constants';
import { UtilsService } from 'src/app/services/utils.service';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-usuariomodal',
  templateUrl: './usuariomodal.component.html',
  styleUrls: ['./usuariomodal.component.css']
})
export class UsuariomodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  comboRoles: any;
  combosList: any;
  usuario: any;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private usuarioService: UsuarioService) {
    this.combosList = [];
    this.comboRoles = AppConstants.ROLES_SISTEMAS;
    this.combosList.push(this.comboRoles);
  }

  ngOnInit(): void {
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.form = this.formService.getUsuarioModalForm(this.data, this.combosList, this.usuario);
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    if (this.form.value.idUsuario > 0)
      this.update(this.form.value);
    else
      this.save(this.form.value);
  }

  save(usuario) {
    let request = {
      idUsuario: usuario.idUsuario,
      idRol: usuario.rol.id,
      correo: usuario.correo,
      usuario: usuario.usuario
    };
    this.usuarioService.guardar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo guardar el usuario, intente de nuevo', true);
    });
  }

  update(usuario) {
    let request = {
      idUsuario: usuario.idUsuario,
      idRol: usuario.rol.id,
      correo: usuario.correo,
      usuario: usuario.usuario
    };
    this.usuarioService.actualizar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo actualizar el usuario, intente de nuevo', true);
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

}
